export interface ReviewDraft {
  verdict: "pass" | "needs_fix";
  gold: string | null;
}

/** Label for the AI suggestion banner. */
export const DRAFT_VERDICT_LABEL: Record<ReviewDraft["verdict"], string> = {
  pass: "模型通过",
  needs_fix: "建议修正"
};

/**
 * The text to pre-fill into the correction box from a draft, or null if none.
 * Never overrides an existing human/canonical gold (existingGoldAfter non-empty).
 */
export function prefillFromDraft(existingGoldAfter: string | null, draft: ReviewDraft | null): string | null {
  if (existingGoldAfter !== null && existingGoldAfter.trim().length > 0) return null;
  if (draft?.gold !== null && draft?.gold !== undefined && draft.gold.trim().length > 0) return draft.gold;
  return null;
}
